import { render } from "./subServiceCard.vue?vue&type=template&id=f04a4d20"
import script from "./subServiceCard.vue?vue&type=script&lang=js"
export * from "./subServiceCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__